import DataTable from "../miscellaneous/DataTable/DataTable";
import { useState, useEffect } from "react";
import api from "helpers/api";
import moment from "moment";
import { useHistory } from "react-router-dom";
import ExportReport from "./Modals/ExportReport/ExportReport";
import DeleteReport from "./Modals/DeleteReport/DeleteReport";
import { FaRegTrashAlt, FaRegEye } from 'react-icons/fa';
import { FcCheckmark, FcCancel } from 'react-icons/fc';
import { BsDownload } from 'react-icons/bs';
import { GrStatusUnknown } from 'react-icons/gr';
import { Link } from "react-router-dom";
import { $t } from "../../helpers/translator";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
// import styles from './ReportsTable.module.scss'
import HasPermission from "../../helpers/permissions/HasPermission";

function MdOutlinePending() {
    return null;
}

function TbRefresh() {
    return null;
}

function ReportsTable({ userType }) {
    const history = useHistory();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ reports, setReports ] = useState([]);
    const [ pagination, setPagination ] = useState();
    const [ payload, setPayload ] = useState({
        sort: 'created_at',
        order: 'desc',   // or desc
        page: 1,
        per_page: 8,
    });
    const [ showExportModal, setShowExportModal ] = useState(false);
    const [ selectedReport, setSelectedReport ] = useState(null);
    const [ deleteReportModal, setDeleteReportModal ] = useState(false);
    const [ selectedDeleteReport, setSelectedDeleteReport ] = useState(null);

    const getAPIUrl = () => {
        return `/report?${Object.keys(payload).map(key => `${key}=${payload[ key ]}`).join('&')}`;
    }

    const getReports = async () => {
        setIsLoading(true);
        try {
            let res = await api.get(getAPIUrl());
            if (res && res.success) {
                const { data, pagination } = res.data.data;
                setReports(data);
                setPagination(pagination);
            }
        } catch (e) {
            console.error(e)
        } finally {
            setIsLoading(false);
        }
    }

    const dataTableActionHandler = (data) => {
        if (data.key === 'page') {
            setPayload({ ...payload, page: data.value });
        } else if (data.key === 'header') {
            const newPayload = { ...payload };
            if (payload.sort === data.value) {
                newPayload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            newPayload.sort = data.value;
            setPayload(newPayload);
        }
    }

    useEffect(() => {
        getReports();
    }, [ payload ])

    useEffect(() => {
        setShowExportModal(selectedReport !== null ? true : false);
    }, [ selectedReport ])

    useEffect(() => {
        setDeleteReportModal(selectedDeleteReport !== null ? true : false);
    }, [ selectedDeleteReport ])

    const tableHeaders = [
        {
            name: 'Date',
            id: 'created_at',
            render: (value) => {
                return moment(value).format('MMMM Do YYYY');
            },
            clickable: true
        },
        {
            name: 'Report Type',
            id: 'type',
            render: (value) => {
                return value.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
            },
            clickable: true
        },
        {
            name: 'Status',
            id: 'status',
            render: (value) => {
                switch (value) {
                    case 0:
                        return <Tooltip content={ $t('global.clinics.pending') }>
                            <MdOutlinePending />
                        </Tooltip>
                    case 1:
                        return <Tooltip content={ $t('global.clinics.processing') }>
                            <TbRefresh />
                        </Tooltip>
                    case 2:
                        return <Tooltip content={ $t('global.clinics.completed') }>
                            <FcCheckmark />
                        </Tooltip>
                    case 3:
                        return <Tooltip content={ $t('global.clinics.failed') }>
                            <FcCancel />
                        </Tooltip>
                    default:
                        return <Tooltip content={ $t('global.clinics.unknown') }>
                            <GrStatusUnknown />
                        </Tooltip>
                }
            },
            clickable: true
        },
        {
            name: 'Clinic/Chain',
            id: 'clinic_chain',
            render: (value, row) => {
                return row.data.clinic && <Link className='clinicLink' to={ `/clinic/${row.data.clinic.id}` }><Tooltip
                    content={ $t('global.clinics.viewClinic') }>{ row.data.clinic.name }</Tooltip></Link>
            }
        },
        {
            name: '',
            clickable: false,
            render: (data, row) => {
                return (
                    <div className="d-flex justify-content-center" style={ { maxWidth: 350, marginLeft: 'auto' } }>
                        <button className="link-button button-medium" onClick={ (e) => {
                            setSelectedReport(row);
                        } }>
                            <Tooltip content={ $t('global.clinics.downloadReport') }>
                                <BsDownload />
                            </Tooltip>
                        </button>
                        <HasPermission permission="report.view">
                            <button className="link-button button-medium" onClick={ (e) => {
                                history.push(`/report/${row.token}`);
                            } }>
                                <Tooltip content={ $t('global.clinics.viewReport') }>
                                    <FaRegEye />
                                </Tooltip>

                            </button>
                        </HasPermission>
                        <HasPermission permission="report.delete">
                            <button className="link-button button-medium"
                                onClick={ (e) => {
                                    setSelectedDeleteReport(row);
                                } }>
                                <Tooltip content={ $t('global.clinics.deleteReport') }>
                                    <FaRegTrashAlt />
                                </Tooltip>

                            </button>
                        </HasPermission>
                    </div>
                )
            }
        }
    ]


    return (
        <>
            <ExportReport show={ showExportModal } report={ selectedReport } onClose={ (e) => {
                setShowExportModal(false);
            } } />
            <DeleteReport show={ deleteReportModal }
                report={ selectedDeleteReport }
                onClose={ (e) => {
                    setDeleteReportModal(false);
                    setSelectedDeleteReport(null);
                } }
                onSuccess={ async () => {
                    setDeleteReportModal(false);
                    setSelectedDeleteReport(null);
                    await getReports();
                } } />
            <DataTable data={ reports }
                headers={ tableHeaders }
                pagination={ pagination }
                loading={ isLoading }
                apiUrl={ getAPIUrl() }
                onAction={ (e) => dataTableActionHandler(e) }
                exportable={ false }
            />
        </>
    )
}

export default ReportsTable;
